import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import dayjsUtcPlugin from 'dayjs/plugin/utc';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(dayjsUtcPlugin);
dayjs.extend(quarterOfYear);
dayjs.extend(advancedFormat);

function quarterEndDateGMT() {
  // Get the end of the current quarter in UTC
  const endDate = dayjs().utc().endOf('quarter');

  // Format the date as "Jan 24th, 2024"
  return endDate.format('MMM Do, YYYY');
}

export default quarterEndDateGMT;
